// The exception rules of Sales Order What's Happened (D-3 (a)-(f), D-15 (g)) and the Sales Order
// Board's (h) Late for delivery, one per board tile (Sales Order Board D-2). The values are the rule
// letters; the declared order is the board's tile order. Each reason code belongs to one rule
// (lineExceptionRule in line-exception-reasons.ts).
export enum LineExceptionRules {
  tooLongAtStatus = 'a',
  madeBeforeCut = 'b',
  journeyClosedNothingDespatched = 'c',
  pickingListOrTransfer = 'd',
  wrongStockAllocated = 'e',
  despatchedOrInvoicedTooMuch = 'f',
  stagedForCutting = 'g',
  lateForDelivery = 'h',
}
